// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__y7RIn","contextHolder":"contextHolder__qVur0","context":"context__WGXsL"};